<template>
  <div class="optWrap">
    <button class="docOption" v-if="!isAuth && isConnectUser && protocolType != 'UNIT'" @click="utilize">활용</button>
    <button class="docOption" v-if="isAuth && protocolType != 'UNIT'" @click="openUtilizeListPopup">연결관리</button>
    <button class="docOption" v-if="isAuth" @click="editOriginProtocol">수정모드</button>
    <button class="docOption" @click="updateStatus({'readOnlyDocumentOption':true})">문서정보</button>
    <Loading :visible="loading" type="fixed"/>
  </div>
</template>

<script>
import CommNew , {commNewMapMutations, commNewMapGetters} from "@processEditor/CommNew";
import Loading from '@common/loading.vue'
import {v4} from "uuid";

export default {
  data () {
    return {
      crntProtocol : null,
      loading : false,
      isConnectUser : false,
    }
  },
  mixins:[ CommNew ] , 
  components : {
    Loading
  } ,
  props: {
    isAuth: {type: Boolean, default: false},
    connectProtocolData: {type: Object, default: null},
    openUtilizeListPopup: {
      type: Function, default: () => {
      }
    },
    protocolType: {
      type: String,
      default: null
    }
  },
  async mounted () {
    const { protocols } = this.PROCESS_INFO ;
    //this.crntProtocol = protocols.filter(o=>o.id == this.$route.query.protocolId)[0];
    this.crntProtocol = protocols.filter(o => o.innerProtocolId == this.getInnerProtocolId)[0];
    this.isConnectUser = false;
    if(this.user.id == this.crntProtocol.innerCreateUserId){
      this.isConnectUser = true;
    }
  } ,
  watch: {
    //'$route.query.protocolId': {
    'getInnerProtocolId' : {
      async handler() {
        const {protocols} = this.PROCESS_INFO;
        //this.crntProtocol = protocols.filter(o => o.id == this.$route.query.protocolId)[0];
        this.crntProtocol = protocols.filter(o => o.innerProtocolId == this.getInnerProtocolId)[0];
        this.isConnectUser = false;
        if(this.user.id == this.crntProtocol.innerCreateUserId){
          this.isConnectUser = true;
        }
      },
    },
  },
  computed : {
  } ,
  methods : {
    ...commNewMapMutations([
      'updateStatus' , 
    ]) ,
    //단일건 활용
    async utilize() {
      const confirmResult = await confirm("해당 프로토콜을 " +
          "활용<div class=\"tooltip_box\"> <span class=\"tooltip_ico\"></span><div class=\"tooltip_txt\">" +
                "<p>기존 프로토콜을 활용하여 새로운 프로토콜을 생성하는 기능입니다.</p></div></div>하시겠습니까?") ;
      if (confirmResult) {
        try {
          this.loading = true;
          //활용
          //1. 활용 시 한개만 => 추후 링크중 선택하여 활용!
          //2. 활용 시 only_protocol 생성 후 링크 => 기존에 있는 only_protocol 복사해서 만들면 될듯
          const utillizeProtocol = await this.$wApi.protocol.utilize({
            onlyProtocolId: this.$route.query.protocolId,
            connectFlag: 2, // 활용!
            keyOfProtocol : v4(),
            utilizeKeyList: [this.crntProtocol.innerProtocolId],
            isChangeNode : false,
          });
          const protocols = await this.getProtocols();
          this.updateProtocols(protocols);

          await this.$wApi.dictionary.setDictionaryLinkForNewProtocol({
            processId: utillizeProtocol.originProtocolProcessId,
          });
          
          let path = '';
          path = '/protocol/editor' ;
          this.$router.replace({
            path: path,
            query: {
              processId: this.$route.query.processId,
              editorType: 'protocol',
              protocolId : utillizeProtocol.originProtocolId ,
              keyOfProtocol : utillizeProtocol.originKeyOfProtocol ,
            }
          }) ;
          location.reload()
        }catch (error){
          alert("오류 발생.")
          console.error(error);
        } finally {
          this.loading = false;
        }
      }
    },
    editOriginProtocol(){
      /*전체링크 수정모드*/
      this.$emit('editOriginProtocol') ;
    },
    searchProcessNode(){
      this.$emit('searchProcessNode') ;
    }
  } , 
  
}
</script>

<style lang="scss" scoped>
  .optWrap {
    --gap: 8px; 
    --size: 32px; 
    position: fixed; bottom:20px; right:20px;
    display: flex; 
    // flex-wrap: wrap; 
    width: 125px; 
    gap: var( --gap ); 
    z-index: 92;
    transition: transform 0.3s ease;
    transform: translateX(calc(var( --nodeinfo-width ) * -1 )); 
    justify-content: end; 

    .publishWrap{
      position:absolute;
      right:0;
      bottom:40px;
      width: 125px;
      
      >button{
        display: flex; 
        border: 1px solid #6C79A8; 
        width: 100%; 
        height: var( --size ); 
        justify-content: center; 
        align-items: center; 
        font-size: 14px; 
        color: $gray-3; 
        flex-shrink: 0; 
        @include text-prt-sb;    
        background-color: #F0F6FF;
        &:after {
          content:'';
          display: inline-block; width:14px; height: 14px;
          margin-right: 5px;
          background: url('@/assets/icons/icon-publish.svg') center no-repeat;
        }        
      }
      >.publishStatus{
        display:flex;
        justify-content: flex-end;
        align-items: center;
        padding-bottom:5px;
        @include text-prt-sb;    
        font-size:14px;
        >span{
          display:block;
          width:10px;height:10px;
          border-radius:50%;
          margin-right:5px;
        }
      }
    }
    &.move {
      transform: translateX( 0 ); 
    }
    > button , > a {
      display: flex; 
      border: 1px solid $gray-d; 
      width: 100%; 
      height: var( --size ); 
      justify-content: center; 
      background-color: #fff;
      align-items: center; 
      font-size: 14px; 
      color: $gray-3; 
      flex-shrink: 0; 
      @include text-prt-sb; 
      &.docOption {
        width: calc( 100% - var( --size ) - var( --gap )); 
      } 
      &.historyList {
        font-size: 0; 
        background: url('@/assets/icons/clock.svg') no-repeat center center #fff; 
        width: 32px; 
        flex-shrink: 0; 
      }
      &.historySave {
        background-color: $gray-e; 
      }
    }
  }

  .wikiViewerPopup {
    @include modalLayoutBlur;
    
  }

  .alertPopup {
			display: flex; align-items: center; justify-content: center;
			/*position: fixed; top:0; left:0; right:0; bottom:0;*/
			.layout {
				padding: 24px;
				border: 1px solid #999;
				background: #fff;
			}
			z-index: 5;
			.title {
				margin-bottom: 6px;
			}
			.content {
				font-size: 12px;
				line-height: 24px;
				color: #999;
			}
			.buttons-wrap {
				display: flex; justify-content: center; gap: 8px;
				margin-top: 14px;
			}
		}
</style>